import { useRef } from "react";
import { twMerge } from "tailwind-merge";
import { type SxProps, type Theme } from "@mui/material/styles";

import SmsSimulatorSimulationsForm from "containers/sms-simulator/sms-simulator-simulator/sms-simulator-simulations-form";
import { Button } from "ui/button";
import AllSimulationsCard from "containers/sms-simulator/sms-simulator-simulator/components/all-simulations/sms-simulator-all-simulations-card";
import { IconButton } from "ui/icon-button";

import { useSmsSimulatorSimulation } from "containers/sms-simulator/sms-simulator-simulator/use-sms-simulator-simulations";

import { SMS_SIMULATOR_STYLES } from "containers/sms-simulator/sms-simulator.styles";

import Icons from "assets";

const MINIMIZE_BUTTON_SX: SxProps<Theme> = (theme) => ({ color: theme.palette.grey[500] });

export const SmsSimulatorSimulations = () => {
  const {
    simulations,
    isAllSimulationsCardOpen,
    isLoadingAllSimulations,
    isSimulatorMinimized,
    handleAllSimulationsClick,
    handleCloseAllSimulationsCard,
    handleMinimizeClick,
    handleSelectSimulation,
    formatDate,
  } = useSmsSimulatorSimulation();

  const allSimulationsButtonRef = useRef<HTMLButtonElement>(null);

  return (
    <div className="px-8 py-4 overflow-y-auto relative">
      <div className="flex justify-between items-center">
        <div
          className={twMerge(
            "flex gap-2 transition-all duration-500 ease-in-out",
            isSimulatorMinimized
              ? "bg-white rounded-lg shadow-xs px-4 py-2 opacity-100"
              : "bg-transparent rounded-none shadow-none px-0 py-0 opacity-100",
          )}>
          <h1 className={SMS_SIMULATOR_STYLES.heading}>Simulation details</h1>
          <IconButton
            aria-label="Minimize simulations"
            variant="text"
            size="small"
            sx={MINIMIZE_BUTTON_SX}
            onClick={handleMinimizeClick}>
            <Icons.Topbar />
          </IconButton>
        </div>
        <Button
          ref={allSimulationsButtonRef}
          variant="contained"
          startIcon={<Icons.Layers />}
          onClick={handleAllSimulationsClick}>
          All simulations
        </Button>
      </div>
      <div className="mt-4 relative">
        {isAllSimulationsCardOpen && (
          <AllSimulationsCard
            simulations={simulations}
            isLoading={isLoadingAllSimulations}
            onClose={handleCloseAllSimulationsCard}
            onSelectSimulation={handleSelectSimulation}
            formatDate={formatDate}
            buttonRef={allSimulationsButtonRef}
          />
        )}
        <SmsSimulatorSimulationsForm isSimulatorMinimized={isSimulatorMinimized} />
      </div>
    </div>
  );
};

export default SmsSimulatorSimulations;
